import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'

export const searchList = (idList) => fetchApi.post(constants.ENDPOINT_SEARCH_LIST_CATEGORIES, idList)
export const searchCategories = (search) => fetchApi.get(constants.ENDPOINT_SEARCH_CATEGORIES, search)
